// Generated by scripts/sprites.ts from art/bullethead/ (M75: the user's AI-generated art, its terms in art/bullethead/provenance.json), each picture's pixels on its grid (initial-phase.png 14.881 by 14.910, terminal-phase.png 12.950 by 12.913 of the picture's a pixel), and drawn whole (young.png cleaned at 1100 by 409, in runs); do not edit. Rebuild: npm run sprites.
import type { Picture, Sprite } from './spriteTypes';

export const BULLETHEAD_SPRITES: Readonly<Record<'adult' | 'terminal', Sprite>> = {
  "adult": {
    "width": 81,
    "height": 33,
    "palette": [
      "#502d26",
      "#834d43",
      "#1f1c1e",
      "#3b1f19",
      "#9d7c73",
      "#dcc2ab",
      "#8d6a61",
      "#020201",
      "#99544c",
      "#c6a891"
    ],
    "rows": [
      "..........................aaaaaabbaaabaaaaa......................................",
      ".......................aaaabbbabbbaabbaabbaaaaaa.................................",
      ".....................aabaabbbaabbaabbaabbbaabbaaaaaaa............................",
      "...................aaabaabbbaabbaabbaabbbaabbbaabbaaaaaa.........................",
      ".................ddaaaaaaaaaaaaaaaaaabbbaabbbaabbbabbbaabaa......................",
      "..............aaaaaaaabbaabbaabbaaabaaaaaabbaabbbaabbaabbaaaa....................",
      "............aaaaaaaaaaabbaabbaabbaabbaabbaaaabbbaabbaabbbaabbaa..................",
      "...........aaaaaaaaaaaaabbaabbaabbaabbabbaabbaaaabbaabbaaabbbaaaa............aaaa",
      "..........aaaaaabbbaaaaaabbaabbaabbaabaabbaabbaggaaaabbaabbbaabbaa.........aaaaaa",
      "........aaaaaabbbbbbaaabaabbaabbaabbabbaabbaabbaeeaegaaabbbaabbbaaa......aaaaaaaa",
      ".......aaaaabbbbbaaaaaabbaabbabbbaabbabbaabbabggaeeaeagebaaabbbaab.....aaaabbbbaa",
      "......aaaaabbbbbaaaaaaaabbaabaabbbabbaabbaabbabeeaeebeaeebeeaaaaba...aaabbbbbaaaa",
      "....aaaaaaabbbaaaaaaaaaaabbabbaabbaabbabbbaabbabeeaeageaeebeeeaba..aaaabbbbaaabba",
      "...aaaaabbbbaaaaaaaaaaaaaabaabbaabbabbbabbbaabbabebaeaeeaeebeeebaaaaabbbbaaabbbba",
      "..aaaaabbbbbaaabbaaaaaabbaabaabbaabaabbaabbaaabbabeaeeaeeaeebeeeeeeeeaaaaabbbbaaa",
      ".aaabbbbhhbbaaabbbaaaaaabbabbaabbaabaabbaabbaabgabeaaeeaeebeebeeeeeeeeabbbbbaaaaa",
      ".aabbbbbhhbaaabbbbaaaaaabbaabaabbbabbaabbaabbaabeaaeaaegaeebeegeeccceeaaaaaaaaaaa",
      "aabbbbbbbbbaaabbbbaaaabaabbaabaabbaabbaabbaabbaaebaeeaaeaeebbeeeccccceeaaaaabbbba",
      "afffabbbbbaaaabbbaaaabbbaabbaabaabbaabbabbaabbaaegabeeaeebeebeeeccccceeabbbbbbbba",
      "effffabbbaaaabbbbaaaaabbaaabaaaaaabbabbaabbaabbaaeeageeaeegeebeeccccceeaaaaaaaaaa",
      "effaafbbaaaabbbbbaaababaaaaabbbbiaabaabbabbbaabgaaeeageaeebgeegeccccceeabbbbbbbba",
      ".aafffbbaaabbbbbbaaabbaaabbbbbabbaabbabbaabbbaaggaaegaebaeebeeeeeccceeaaaaabbbbba",
      ".gffffbaaabbbbbaaaabbaaaaaaaabbbbbaabaabbaabbaabggaebeaeaegebeeeeeeeeeaaaaaaaaaaa",
      "..ajffaaabbbbbaaaaabaabaabbbbbaaaaaaababbbaabbaabegaeeaeeaeegbbaaaeeeaabbbbbaaaba",
      "...aaaaabbbbaaaaabbaabbaaaaaabbbibaabbaabbaabbaaeeagbbebgbeaaaa....aaaaaaabbbbaaa",
      "....aaaaaaaaaaaaabaabbbaaaabbbaaaaaaabbaababaaabeabeagebbbaabbaa.....aabbbaaabbba",
      "......aaaaaaaaaabaabbbaabbaaabbbbaababbbaabbaabgabebbaaaaabbaabaa......aabbbaabba",
      "........daaaaaaaaaaaaaabbaaaaaaaaaabaabaabbabbgabgaaaaabbaabbaabaa.......aabbbaaa",
      "...........daaaaaaaaaaaaaaaaaaaaaabaaaaaaaaaaaaaaaaabbaabbaabbaaaa.........aaabaa",
      "................aaaaaaaaaaaaaaaaaaaaaaaad.......aaaaabbaabbaabaaa............aaaa",
      "......................aaabaa.....................aabaabbaabaaa...................",
      "........................aabaa......................aaaaaaaa......................",
      ".........................aaaa...................................................."
    ]
  },
  "terminal": {
    "width": 110,
    "height": 40,
    "palette": [
      "#276744",
      "#16442d",
      "#64a255",
      "#42733f",
      "#8884a9",
      "#de900f",
      "#45875b",
      "#fb9d90",
      "#50b8af",
      "#a28624",
      "#010101",
      "#6b7b35",
      "#83812e",
      "#c38c17",
      "#053e47",
      "#106768",
      "#d8a289",
      "#e9902a",
      "#2d9992",
      "#2e5630"
    ],
    "rows": [
      "...............................bbbbbbbbbbbbbbbbb..............................................................",
      "............................bbbaccaaaaccaaaccaaabbbbbbbbbbbbb.................................................",
      "..........................bbaaaccaaaaccaaaccaaacccaaaccaacccabbbbb............................................",
      "........................bbbaaaccaaacccaaaccaaacccaaaccaacccaaaccaabbbbbbb.....................................",
      "........................bbaaaccaaacccaacccaaacccaaaccaaaccaaaccaaaccaaaaabbbbb................................",
      "......................bbbbbbbbbbbbbbbaabccaabccaacccaaaccaaaccaaaccaaacccaaaaabbbbb...........................",
      "...................bbbaaabbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbaaaccaaacccaacccaaaccaaaccabbb........................",
      ".................bbaaaaaaahhaaahhaahhhaahhaaahhaaahhabbbbbbbbaacccaacccaaaccaaaccaaacabb......................",
      "...............bbaaggggggathhaaahhaahhhaahhaaahhaahhaahhabbbbbbbbbaaccaaaccaaaccaaacccaabbb.............bbbbbb",
      ".............bbageeeegggeeaahhaaahhaahhhaahhaaahhaahhaahhaaahhaaaatbbaaacccaaccaaacccaaccaabb.........bbaaaaab",
      "...........bbaaeeeeegggeeegaahaaaahaaahhaaahaaaahaaahaaahhaaahhaahhaaabbbbaacccaacccaaccaaaab.......bbaaaaaaab",
      "..........baageeeeegggeeegaddahhdddhhdddhdddhhdddhddahhddhhadahhdahhaaahhaabbbbaaccaacccaaccb.....bbaaaaccccab",
      "........bbageeeeeegggeeeaaahhddhhldqhhdlhhdddhhddhhddhhhddhhdddhhddhhddahhddhhabbbbaaccaaccbb....baaaaccccaaab",
      ".......baageeeeegggggggaaaddhhllhhlllhhllhhlllhhllhhllhhllllhhddhdddhhdddhhddhhddhhabbbaacab....baaaacccaaaaab",
      "......baggeeeeegggggggggadhllhhlmhhmmmhhmmhhmmmhhmmhhlmhhmllhhlllhlllhhlddhhddhhddhhahhbbbb....baaaacccaaaaaab",
      ".....bageeeeeggggggeeegggahhjjhhjjjhjjjhjjjhjjjjhjjjhjjjjhjjjhhjjhhmlmhllllhlllhlllhhdhhdaabbbbaaaaccaaaacccab",
      "....bageeeegggggeeeeeggggdlhhjjhhnnhhnnnhfnnhhnnnhnnjhhjnjhhjjhhjjhhjjjhhmmmhmmmhhllhllhhddhhdaaaaccaaacccccab",
      "...bageeeeggggeeeeeeeegggganhfffhfffhhffhhffhhfffhhffhhhffhhfffhfffhfffhhhjjhhjjhhhjmhhlhhllhhddaaaaaccccaaaab",
      "..bageeeegkkgeeeeegggeeeggaffhhffhfffhfffhhffhhfffhhffhhhffhhfffhhffhhffhhfffhffffhjjhhjjhhllhlhhdaacccaaaaaab",
      ".bageeegggkkeeeeggggggeegffffhhffhhffhhffhhfffhhfffhhffhhfffhhffhhfffhhfffhhffhhffhhffhfjjhhjhhlhhdaaaaaacccab",
      ".baeeeggggkkeeggggggggeegffhffhhffhfffhfffhhfffhfffrhffffhfffhfffhhfffhhffhhffhhfffhhffhhjjhjjhhmhhaaaccccccab",
      "biiiiiggggeeegggggggeeecgajhhffhhffhfffhfffhffffhfffhffffhfffhhffhhfffhhfffhfffhhffhhfffhhffhhjhmlhaaaaaaaaaab",
      "biiiiiiageeeggggggeeeeccabmfhhffhfmbbbbbbaffhhffhhfffhhfffhfffhhfffhffffhhffhhffhffffhhffhhfhhjjhllaaaaaaaaaab",
      "piiiiboieeeggggggeeeecccadhnnhhbbbbcccccablnhhnnnhhffhhfffhhfffhhffhhfffhhfnfhfffhhffhhhnfhhjhhjhhdaacccccccab",
      "oobbbiiieeggggggeeeecccaahhhjlbbccccaaaaaabjjhhjjjhjjjhhjjjhjjjhhjjjhhjjjhhjjjhjjjhhjjhhmmhhmlhllhaaaaaaccccab",
      "..psiiiigggggggeeeccccaaddhhldbacaaaccccccblllhhlllhllmmhhmmhmmmmhmlmhlhlmhhllhhlllhhllhhllhhddhdaaaccaaaaaaab",
      "..bsiiisggggggeeeccccaabhhddddabacccaaaaaabhdddhdddhhdddhhddhhdddhhdddhhhddhhddhhdddhhddhhddhddhaaaaacccaaaaab",
      "...ossssaggggeeecccccaahhadddhdabaaaaaaaaabhhddhdhddhdhddhhddhhdddhhdddhhddhhhddhhddddabbbbbbaaaaaccaaccccaaab",
      "....bsssaggeeeecccccaadhddddhhddbbccccccccbdhhdddhhddhhdddhdddhhddhhhdddhhdddhddddaabbbb.....bbbaaaccaaaccccab",
      ".....oooogeeeecccccaahhdddhhhdddhbbcaaaaaabddhddddhdddhhddddhddhdddhddhdahhdddabbbbaccaab.......bbaacccaaaccab",
      ".......bbaaeeccccaabdhdddhhddddhhdbbcccccbhhddhhdddhhddhhddhhddhhddddhhadddabbbacccaaccaab.......bbaacccaaacab",
      ".........obbaaccaaadhaddhhddddhhdddbbcccbahddhhdddhhddddhdhhddhhddddhdaabbbbaccaacccaaccab.........bbaccccaaab",
      "............bbbbbbdddddaadadhhddaaaaabbbahhdhhdddhhdddddddddddaabbbbbbbbbaccaaccaacccaaccb..........bbaaccccab",
      "...............bbbbbbaaadddaaaaaadaaadaaaddddadddaaaabbbbbbbbbbaaaccaacccaaccaaccaaaccabb.............bbaaaaab",
      "....................bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb........bbaaaccaaccaaaccaaccaaabb.................bbbbbb",
      "................................baacccaab.......................bbaaccaaccaaaccaabbbb.........................",
      ".................................bbacccaab........................bbbaaaaccaabbbb.............................",
      "..................................bbaaccaab.........................bbbbbbbbb.................................",
      "....................................bbaccab...................................................................",
      "......................................bbbbb..................................................................."
    ]
  }
};

export const BULLETHEAD_PICTURES: Readonly<Record<'young', Picture>> = {
  "young": {
    "width": 1100,
    "height": 409,
    "palette": [
      "#4b381f",
      "#f2ecdc",
      "#362d18",
      "#6b6139",
      "#b8ac82",
      "#735e2f",
      "#ab9554",
      "#544b2b",
      "#605133",
      "#86775e",
      "#ddd7c5",
      "#9a8d75",
      "#050402"
    ],
    "rows": [
      ".365c106.629",
      ".365c107.628",
      ".365c107.628",
      ".365c107.628",
      ".365c107.628",
      ".365c107.628",
      ".365c107.628",
      ".365c107.628",
      ".365c107.628",
      ".364c108.628",
      ".364c108.628",
      ".364c108.628",
      ".364c108.628",
      ".364c108.628",
      ".364c108.628",
      ".364c108.628",
      ".364c108.628",
      ".361di2c108.628",
      ".300c31id31ic24ai5d7i11d5ac28i23dic107.522",
      ".300c31id32c23aid28iac26i2d25c107.521",
      ".300c31id32c23ad29iac26id26c107.521",
      ".300c31id32c23ad29iac26id26c107.521",
      ".300c31id32c23ad29iac26id26c107.521",
      ".300c31id32c22ahd29ic27id26c107.521",
      ".300c31id32c22ahd29ic27id26c107.521",
      ".300c31id32c22ahd29ic27id26c107.521",
      ".300c31id32c22ahd29ic27id26c107.521",
      ".300c31id32c22ahd29ic27id25ic107.521",
      ".300c31id32c22ahd29ic27id25ic107.521",
      ".299c32id32c22ahd29ic27id25ic107.521",
      ".299c32id32c23hd29ic27id25ic107.521",
      ".299c32d33c23ad29ic18ac7aid25ic107.521",
      ".299c31ad32ic23ad29ic16a5c4a2d26hc107.521",
      ".299c31ad32ic23ad29ic16a8ca2d26hc107.521",
      ".299c27a4id31iac22ahd28iac15a11id25hac107.521",
      ".283c33hi13d18h6a9c16h8d17h9a4c13ah2i11d16a11c17h8i6h15c30ah30c70.452",
      ".282c33hid30hac29h2d23h2ca7c16ahd28ac27hd28ihc28ahd29ihc69.452",
      ".282c33hd31ac30hd24hc25ad29ac27d30ic28ad31hc69.452",
      ".282c33id31ac30hd24hc25ad29ac27id29ic28ad31hc69.452",
      ".282c33id31ac30hd24hc25ad29ac23ac2ad30ic28ad31hc69.452",
      ".282c33id31ac30hd24hc25ad29ac23a4d30ic28ad31hc69.452",
      ".282c33id31ac30hd23ihc25ad29ac23a4d30ic28ad31hc69.452",
      ".282c33id31ac30hd23ihc25ad29a2c22a4d30ic28ad31hc69.452",
      ".282c33id31ac30hd23ihc25ad29a2c22a4d30ic28ad31hc69.452",
      ".282c33id31ac30hd23ihc25ad29a2c24a2d30ic28ad31hc69.452",
      ".282c33hd31ac29ahd23ihc25ad29ac25a2d30ic28ad31hc69.452",
      ".282c33hd31ac29aid23ihc25ad29ac26ad30ic28ad31hc69.452",
      ".282c33hd31ac29aid23ihc25ad29ac26ad30ic28ad31hc69.452",
      ".282c33hd31ac29aid23ihc25hd29ac26ad30ic28ad31hc69.452",
      ".282c33hd31ac29aid23ihc25hd29ac26ad30ic28ad31hc69.452",
      ".282c32h2d30hac27a2hid23hac16a8h2d28hac25ahd29ihc28hd30h2c69.452",
      ".279c21a10h5d17h14ac18h12id15h6a4c12h14d17h12ac13a8h6d16ih14c15h14d17ih14c17a9h7a8h7c23.451",
      ".236c63ahi10d20hac31hid26h2c20hid29hac24a2d28ihc28h2d29ihc30aid29h2c95.378",
      ".236c63hi3d4i2d22ac32id27hc21id30ac25ad29ic29hd30ic31hd31hc95.378",
      ".236c63hi3d4i2d22ac32hd27hc21id30ac25ad29ic29hd30ic31hd31hc95.378",
      ".236c63hid30ac32hd27hc21id30ac25ad29ic29hd30ic31hd31hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29ic29hd30ic31hd31hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29ic29hd30ic31id31hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29ic29hd30ic31id31hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29ic29hd30ic31id31hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29ic29hd30ic31id31hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29ic29id30ic31id31hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29hc29id30ic31d32hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29hc29id30ic30ad32hc95.378",
      ".236c63hd31ac32hd27hc21id30ac25ad29hc29id30ic28acad32hc95.378",
      ".236c63hd31ac32id27hc21id30ac25ad29hc29id30ic30ad32hc95.378",
      ".236c63hid29hac32aid25hac21hd29hac24a2d28h2c28aid29ihc25a6d32hc95.378",
      ".236c64h30ac34a7h14a6c23h29ac15a10hd17ih5i3h4c17h4a8hd17i12h2c19a12d18i4h7i3hc28a5c6a2c2a5c48.378",
      ".207c252aid26ihc28hid28ihc2a8c20aid29iac31id29iac31ai14a2c15.c58.303",
      ".207c252id27ic29id29hc30aid30hc31id31ic30aid14iac74.303",
      ".207c252id27ic28aid29hc30ad31hc31id31ic30ad16c75.303",
      ".207c252id27ic27a2d30hc30ad31hc31id31ic30ad16c75.303",
      ".207c252id27ic27a2id29hc30ad31hc31id31ic30ad16c75.303",
      ".207c252id27ic28aid29hc30ad31ac31id31ic30ad16c75.303",
      ".207c252id27ic29id29hc30ad31ac31id31ic31d16c75.303",
      ".207c252id27ic29id29hc30hd31ac31id31ic31d16c75.303",
      ".207c252id27ic29id29hc30hd31ac31id31ic30ad16c75.303",
      ".207c252id27ic29id29hc30hd31ac31id31ic30ad16c75.303",
      ".207c252id27ic29id29hc30hd31ac31id31ic30ad16c76.302",
      ".207c252id27ic29id29hc29ahd31ac31id31ic30ad16c76.302",
      ".207c252id27ic29id29hc27a3hd31ac31id31ic30ad16c76.302",
      ".207c252id28c29id29hc27acahd31ac31hd31ic30ad16c76.302",
      ".207c252aid26ac29aid27hac26a4hd30iac30ahd30i2c29a2d16c76.302",
      ".207c253a27c31a29c17ah13d17i9h5ac17a14hd17i6d6i3c29a2id16ac75.302",
      ".174c42a14c2a83c248ad30iac2a2c26ahd30ihc31h8i6d17ac29h3a11h16ac15.302",
      ".173c34a109c247d31ac31hd31hc31hid30ac28hd30hac62.254",
      ".173c34a109c247d31ac31hd31hc31id31ac28d32ac62.254",
      ".173c34a109c247d31ac31hd31hc31id31ac28d32ac62.254",
      ".173c34a109c247d31ac31hd31hc31id31ac28d32ac62.254",
      ".173c34a109c247d31ac31hd31hc31id31ac28id31ac62.254",
      ".173c34a109c247d31ac31hd31hc31id31ac28id31ac62.185c69",
      ".173c34a109c247d31ac31hd31hc31id31ac28id31ac62.185c69",
      ".173c34a109c247d31ac31hd31hc31id31ac28id31ac62.185c69",
      ".173c34a109c247d31ac31hd31hc30aid30ic29id31ac62.185c69",
      ".173c34a109c247d31ac31hd31hc30aid30ic29id31ac62.185c69",
      ".173c34a109c247d31ac30ahd31hc30aid30ic29id31ac62.185c69",
      ".173c34a109c247d31ac30ahd31hc30aid30ic29id31ac62.185c69",
      ".173c34a109c247d31ac30ahd31hc30aid30ic29id31ac62.185c69",
      ".173c34a109c247ad29hac30ahd30ihc30aid28i3c29id31ac62.185c69",
      ".173c34a110c247a2h27ac31ahd16i5h5i4hc18a13id16i15c29hid31ac62.185c69",
      ".173c33a245c175hd15ihc31ad30ic29ah8i3h2id31ac63.185c69",
      ".133c41a278c174hd15hc31ad31c30hd31ha4c26ai7d6i16hc54.147c69",
      ".132c41a279c174hd15hc31ad31c30d31ha3c27aid30hc53.147c69",
      ".132c41a279c174hd15hc31ad31c30d31ha2c28ad31hc53.147c69",
      ".132c41a279c174hd15hc31ad31ac29d31ha2c27a2d31hc53.147c69",
      ".132c41a279c174hd15hc31ad31ac29d31hac28a2d31hc53.147c69",
      ".132c41a279c174hd15hc31ad31ac29d31hc29a2d31hc53.147c69",
      ".132c41a279c174hd15ic31ad31ac29d31hc27a3hd31hc53.113c51ai4d26i2hc18",
      ".132c41a279c174hd15ic31ad31ac29d31hc26a4hd31hc53.113c50ad33iac17",
      ".132c41a279c174hd15ic31ad31ac28ad31hc27a3hd31hc53.113c50ad34ac17",
      ".132c41a279c174hd15ic31ad31ac28ad31ac27a3hd31hc53.113c50ad34ac17",
      ".132c41a279c174hd15ic31ad31ac28ad31ac27a3hd31hc53.113c50ad34ac17",
      ".132c41a279c174hd15hc31ad31ac28ad31ac29a2d31hc53.113c50ad34hc17",
      ".132c41a279c174hd15hc31ad31ac28ad31ac29a2d31hc54.112c50ad34hc17",
      ".132c41a279c175hd13hac31aid29ic29ad31ac29a2d31hc54.112c50ad34hc17",
      ".132c41a36h5i24d17j39l3j2l36da117c65a2c4a2c29a6c67a8c3a3c33ai28hc29aid30hac29a2d31hc54.112c50ad34hc17",
      ".132c40a36hdkb124lda256c130i12d18i7h6ac23a8d26i5hc55.112c50ad34hc17",
      ".109c24a75dkb126da257c128id29ia6c25hd31a3c28hi6d13i2d6hc46.75c50ad34hc17",
      ".109c23a76dkb126da257c127ad30a5c26hd31a2c29hid28hc46.74c50ad34hc17",
      ".109c23a74cadkb126da257c127ad30a5c26id31a2c29hd29hc46.74c50ad34hc17",
      ".109c23a74cadkb126da257c127ad30a4c27id31ac30hd29hc46.74c50ad34hc17",
      ".109c23a74cadkb126da257c127ad30a4c27id31c31hd29ac46.74c50ad34hc17",
      ".109c23a74cadkb126da257c127ad30a4c27id31c31hd29ac46.74c49ahd34hc17",
      ".109c23a74cadkb126da257c127ad30a3c28id31c31hd29ac46.74c18h31id35hc17",
      ".109c22a77dkb126da257c127ad30c31id30ic31id29ac46.47c44h2d17i4d45hc17",
      ".109c22a77db127da257c127ad30c31id30ic31id29ac46.47c44hd67hc17",
      ".109c22a77jb127da257c127ad30c31id30ic31id29ac46.47c44hd67hc17",
      ".109c22a77jb127dha256c127ad29ic31d31ic31id29ac46.47c44hd67hc17",
      ".109c22a77jb128dh14i22d9i7d10j2d2j5d3a182c127ad29ic30ad31ic31id29ac46.47c44hd67hc17",
      ".109c22a77jb202lda181c127ad29ic30ad31ic31id29ac46.47c44hd67ac17",
      ".109c22a76j2b203la181c127ad28i2c30ad31ic31id29ac46.47c44hd67ac17",
      ".109c22a13d7j57b204la182c127ai7d13i8c18a2c3a8d31ic31i2d28a2c46.47c43ahd67ac17",
      ".79c2.c28a33dkb267la261c94ad31a5c26hi14d17ha12c16h10i5c16.47c43ahd67ac17",
      ".79c30a34kb80k6e89b93la262c93d31a2c29aid30hac27aid14ic15.47c41a3hd67ac17",
      ".79c30a34kb79klah6a25h6a40h3a10h2leb92la262c93d31ac30ad31hc28ad16c15.47c40a4hd67ac17",
      ".79c30a34kb79ea95lb92la262c93d31ac30ad31hc28ad16ac14.47c40a4hd67ac17",
      ".79c30a34kb79ea95lb92la262c93d31ac30ad31ic28ad16ac14.47c40a4hd66a2c17",
      ".79c30a34kb79ea95lb92lc2a260c93d31ac30hd31ic28ad16c15.47c38a6hd25h2a12h21a7c18",
      ".79c30a34kb79ea95lb92ljca260c93d31ac30hd31ic28ad16c15.47c30a11hahd25h2c59",
      ".79c30a34kb79ea95lb93lj3l20el7e42k9e9a170c93d31ac30hd31ic28ad16c15.47c18a9id41hc60",
      ".79c30a34kb79ea95jb184k2a169c93d31c31hd31ic28ad16c15.46c18aid50hc60",
      ".79c30a34kb79ea95jb185ka169c93d31c31hd31hc28hd15ic15.30c34id51hc60",
      ".79c30a34b80ea95jb185ka169c93d31c31hd31hc28hd15ic15.30c34id51hc60",
      ".79c30a34b80la95jb185ka169c93d31c31hd31hc28hd15ic15.30c34id51hc60",
      ".79c30a34b80la95jb185ka169c93d31c30ahd31hc28hd15ic15.30c34id51hc60",
      ".79c30a3c2a29b80la95jb185kha168c93d31c30ahd31hc28ad15ic15.30c34id51hc60",
      ".79c30a3c2a28kb79kla95jb185kha169c92hd29hc28a3hd31hc27a2d15ic15.30c34id51hc60",
      ".79c29a2hk32b37k42la96jkb184kha215c47h3i20h6c18a13hd25i5dhc14a2c9a4hid14ac.44c34id51hc60",
      ".48c32a29hkb64eh4a140le25l5j17d13i13db110kdha215c92aid30ic27a2d13i2hc15.45c34id51hc60",
      ".48c31a30hb64eha218hdb110kd26j21l33e22l2da111c92hd30ic28aid14ic16.45c33ad52hc60",
      ".48c31a30hb64ea220db215lda110c92hd30ic28aid14ic16.45c33ad52hc60",
      ".48c31a30hb64ea220db216da110c92hd30ic28ad15ic16.45c33ad52hc60",
      ".48c31a30hb64ea220db216da110c92hd30ic28ad15ic16.45c33ad26i2d5i10d8hc61",
      ".48c31a30hb64ea220db216da110c92hd30ic28ad15hc16.45c25a8d26ihc36a32c18",
      ".48c31a30hb64ea220db216da110c92hd30ic28ad15hc16.45c17aid40ic36ahd30hac17",
      ".48c31a31b64ea220db216da110c92hd30ic28ad15hc16.45c17id41ic36hd32hc17",
      ".48c31a31kb63ec2a218db216da110c92hd30ic27a2d15hc16.44c18id41ic36hd32hc17",
      ".48c31a31kb63ec2a217hdb216ja110c92id30ic27a2d15hc16.44c18id41ic36hd32hc17",
      ".48c31a31kb63ec2a217hjb216ja110c92id30ic28ad15hc16.44c18id41ic36hd32hc17",
      ".48c31a31kb63ec2a217hdjb31k19e41kb123ja110c92id30ic28ad15hc16.28c34id41ic36hd32hc17",
      ".48c31a31kb62kec2a219i21h10a61ekb122jaca108c92id30ic28aid14hc16.27c35id41hc36hd32hc17",
      ".48c31a31kb63ec2a309ca2kb122jda5h4a81h2a17c92id30ic28aid14hc16.27c35id41hc36hd32hc17",
      ".48c31a30k2b62kea314kb123l9j17l31e27l5e4a18ca5c26a12c47aid28iac29hd13ihc16.27c35id41hc36hd32hc17",
      ".48c4a23c3aek30b16k12e36a315kb215kea91c18a30c30ah14c17.27c35id41hc36hd32hc17",
      ".32c16a30k2b45kla362kb216ka92c96.40c35id41hc36hd32ac17",
      ".32c16a30kb46la363kb216ka92c93.43c35d41ihc36hd32ac17",
      ".32c16a30kb46la363kb216ka92c93.43c35d28i2d4i7hc37hd32ac17",
      ".32c16a30kb46la363kb216ka92c93.43c35d27iac50hd32ac17",
      ".32c16a30kb46la363kb216ka92c93.43c35d27ac51hd32hc17",
      ".32c16a30kb46la363jkb215ka92c93.43c35d27ac50aid32hc17",
      ".32c16a29hkb46la364j3l9j24d39i29hkb110ka92c93.43c34d28ac25a3c17a5id33hc17",
      ".32c16a29hkb46la469hkb109ka92c93.43c19i7d36ac20hd63hc17",
      ".32c16a29hkb46la470kb109kda18h5a51ha16c93.43c18id43ac19hd64hc17",
      ".32c16a29hkb46la470kb110kd5j20l19e25k7e3ha11c93.43c18d44ac19hd64hc17",
      ".32c16a29ikb46la470kb190eha10c93.43c18d44ac19hd64hc17",
      ".32c16a29ib47la470kb191ha10c93.43c18d44ac19hd64hc17",
      ".32c16a29ib47la470kb191ha10c93.43c18d44ac19hd64hc17",
      ".32c16a3h8a14h4lb47la470kb191ha10c93.43c18d44ac19hd64hc17",
      ".32c5a5c5aj7l6j8l8b47e2ga86h8a34h4a4h5a328kb191ha11c92.43c18d44ac19id64hc17",
      ".32a15leb45el15e15g30fa51j48l38e37da265kb191ha86c17.43c18d44ac19id64hc17",
      ".17c15a15eb45l2a14f15g32fa49j2b122eda264kb190kha87c76ad44ac19id64hc17",
      ".17c15a15eb45lha15f15g31fa49jb124da264kb190kha88c75ad44ac19id64ac17",
      ".17c15a15eb45eha15f15g31fa49jb124da264ikb49k43b97kha98c65ad44ac19id64ac17",
      ".17c15a15eb45eha15f15g31fa49jb124da265i7d4i2d3i2d2i2d10i2h4i11h4a3h13a23ekb97ha102c61ad43iac19id64ac17",
      ".17c15a15eb45lha15f15g31fa49jb124da358ekb96ha102c61ad17i26ac20id64ac17",
      ".17c15a15eb45la16f15g31fa49jb124da356caekb96ia6h3a93c61ad16i2c45aid63hac17",
      ".17c15a15eb45la16f15g31fa49jb124da358ekb96ki3d18i11d38j12djdha16c62d16ic32a14id23h36a6c18",
      ".17c15a15eb45la16f15g31fa49jb124da356c2ekb181kja16c62d16ic31ahd36h2c59",
      ".17c15a15eb45la16f15g31fa48hjb124da358ekb182ka17c61d16ic31hd37hc60",
      ".17c15a15eb45la16f15g31fa48hjb124eia23h6a10hi6d2i10d7j14a278eb183ka17c61d16ic31hd37hc60",
      ".17c15a15eb45la16f13i2jg30da48hjb125e5k35b39l2a277eb183ka17c61d16ic31hd37hc60",
      ".17c16a14eb45la16if11i3jg30fa48hjb205lc2a275eb183ka17c61id15ic31hd37hc60",
      ".17c15a14ieb44kla16if11i2f2g30fa48hjb205lc2a275eb183kha16c61id15ic31hd37hc60",
      ".17c15i14lb17k28la17if15i6d10g14fa26h3a15h3ajkb205lc2a275leb182kha17c60id15ic31hd37hc60",
      ".c15a13c2ijb3k5b22klh2a43fg13fiam14cdg13fa17e5k27b206lc2a276l31j24d15j9kb103kha33c44id15ic31hd37hc60",
      "c16a15jb31lha45g15am16cg13fa16ekb237lc2a355dkb102kha34c43d16ic31hd37hc60",
      "c16a15jb31lha45g15am16cg13fa16kb238lc2a356kb102kha34c43id15ic31hd37hc60",
      "c16a15jb31lha45g15am16cg13fa16kb57k83b98lc2a356kb102keh6a28c14a11c18aid13ic32hd37hc60",
      "c16a15jb31lha45g15am16cg13fa16kb48li7h39a44dkb97lc2a356kb103e43k5ja3ha25c2a10c36hd37hc60",
      "c16a15jb31la46g15am16cg13fa16kb47lha89cadb97la62h10a7ha278kb151kjh3a25c48hd37hc60",
      "c16a15jb31la46g15am16cg13fa16kb47la90cadb97kla22h6i5d14j15l17a278kb152jha27c45a2hid36ihc60",
      "c16a14hjb31la46g15am16cg13fa16kb47la92db98k32b47elha276eb152jha27c44ai3d14i9h15c61",
      "c16a14hjb31la46g15am16cg13fa16kb47la92db178eha276eb152jha24h2ac43aid16ic2ac32a18h14c18",
      "c17a13hjb31la46g15hm16cg13fa16kb47la92db178eha276eb152jha23h3ac43ad16ic35ahd30h2c17",
      ".c16a13hjb31la46g15hm16cg13fa16kb47la92db178eha276eb152jha23h3ac43ad16ic35hd32hc17",
      ".c16a13hjb31la46g15hm16cg13fa16kb47la92db178ea277dkb151jha22h4ac43ad16ic35hd32hc17",
      ".c16a13hjb31la46g15hm16cg13fa16kb47la92db178ea278dj15d39i25d5lb66jha11h4a7h4ac43ad16ic35hd32hc17",
      ".c16a11hahj2b29lja46g15hm16cg14ia8h6lkb47la92db178ea363hlb65ja11h6a6h4ac43ad16ic34ahd32hc17",
      "c16ah8i7j31a47g15hm16cg14l15kb47kla92db178ea364lb65ja11h7a5h4ac43ad16ic34ahd32hc17",
      "a16h2i3f10iha77g15hm16cg13lkb62lia92dkb177ea101h8a255lb65jha10h8a3h5ac43ad16ic35hd32hc17",
      "a16hi4f10ia78g15fam14cdg13kb33d9i3d14i5a93hde10k7e19l15j7l3j10l8b98eia3h7a7h21a49h11i14h3a248lb65jha10h8a4h4ac43ad16ic35hd32hc17",
      "a16hi4f10ia78g16d3f3df8dg14eb32dia137h2a64djb98ed8jdj13l18e17k44b7k5jha247jb65ja11h7a6h2a2c43aid15ic35hd32hc17",
      "a16hi5f9ia78g46eb32da203cadb213kda247jb65eja9h8a6h3ac43aid15ic35hd32hc17",
      "a16hi6f8ia78g46eb32da205db214ja247jb66e2k19e6jaca5c36ahi2d12i2c35hd32hc17",
      "a16hi7f7ha78g46eb32da205db214ja247jb93kj16a16c12ah2i13c36hd32hc17",
      "a16hf2i7f4iha78g46eb32da205db214ja247jb109kja16c19a5c39hd32hc17",
      "a16if2i12ha78jg45kb32da205db214ja247jlb109ea13h2ac63hd32hc17",
      "a16if2i12ha78jg45kb32da205db214ja248j3l17j44kb45ea12h3ac63hd32hc17",
      "a16if2i12ha78jg45kb32da205jb214ja310cadkb44ea12h3ac63hd32hc17",
      "a16if3i11ha78jg45kb32da205jb214ja310cahkb44ea12h4c37a2c23ahd32hc17",
      "a15hf4i9f3ha77hjg43k2b32da204hjkb213ja312hkb44ea9h7c29a33hd33hc17",
      "j8gek52la48h6i6g2ek30b33da205hje8k9e11l4e9l38b134jia311hkb44ea8h8c28ahd66hc17",
      "g7lekb52klha58heb63eda206h2a10h7a60j2b133kji5h5i4d18j18l25e9l5da221hkb44ea8h8c28hd67hc17",
      "g8eb54lha59eb48l2e11l2da207h2a13h3a62jb134k16bk4b69ldha219hkb44ea3h13c28hd67hc17",
      "g8eb54lha59eb47lia302jb225dha219hkb44ehah14c28hd67hc17",
      "g8eb54lha59eb47ia303jb225dha219hkb44eh16c28hd67hc17",
      "g8eb54lha59eb47da303jb225dha219hkb44eh16c28hd67hc17",
      "g8ekb53lha59eb47da303jb225dha219hkb44kh16c28hd67hc17",
      "g8ekb53la60eb47da303jb225dha219hkb44kh15ac28hd67hc17",
      "g8ekb53la60eb47da303jb225da220hkb44kihi3h10ac28hd67hc17",
      "g8ekb53la60eb47da164c69a70jb225da220hekb42ke2i14ac28hd67hc17",
      "g8ekb53la60lb47da163c71a69jb225da221he5k7e12k2e19k15ic28hd67hc17",
      "g8ekb53la60lb47da163c71a69ijk37e2k6e26l45kb107da243h10a12dekb13k2c28hd67hc17",
      "g8ekb53la60lb47da163c71a70i20h2i8h6a5h6a69hjkb106da244h9a13jb15kc28hd67hc17",
      "g8ekb53laca58lb47da163c71a187ikb106jih2a3h8a252jb15kc28hd67hc17",
      "g8ekb53l2a58leb33k2b11kda163c71a187ikb107j45l17e25ha178jb15kc28hid2i3d60ihc17",
      "j8gek6b48e60b17k30dia163c71a187ikb193keha177jb15kc29i26d3i37hc18",
      ".ac5a2h6lkb123kli11h11i4h4a164c71a187ikb194kha177jb15kc114",
      ".c14alb123lh6a189c71a187ikb194kha177jb15kc114",
      ".c15lb123la143h6a12h12a22c71a187hkb194kha177jb15kc114",
      ".c15lb123lha78i2h18i16h4i40d11i3a21c72a187hkb194kha177jb15kc114",
      ".c15lb123lha76hilk93iac91a187hkb194kha177jb15kc114",
      ".c15lb123lha76hjkb92k2c92a187hekb193kha177jb15kc114",
      ".c15lb123lha76hlb94kc93a187ie34l7e3l41j3lkb104kha177jb15kc114",
      ".c15lb123la77hlb94kc107a180h4a78hjkb103ka69h15a94jb15kc114",
      ".c15lb123la77hlb94kc23ai20d2i23d6i11d3hc18a260caikb103kea31h6i21d26a64h9a19djb15kc114",
      ".c15lkb122la77hlb94kc22aid66hc17a262ikb104ke25k59da62id10i17djkb15kc114",
      ".c15jek13b109la77hlb94kc22ad67hc17a262ikb188kea61idk29b16kc114",
      ".c15dge13kb108la77hlb94kc22ad67hc17a262ikb189ea61ikb45kc114",
      ".c15dg13e3ke13kb92ja77hlb94kc22ad67hc16a263ikb189ea61ib46kc114",
      ".2c14hdg13e17k2b89kja77hlb94kc22ad67hc16a263ikb189ea61ib46kc114",
      ".16a3h11dge17k16b48k26jia78lb94kc22ad67hc16a262hikb189ea61ib46kc114",
      ".17ac2a2c8ade32k2b46kdi20h6a78hlb91k3ic22ad67hc16a262hikb189ea60hib46kc27a28c59",
      ".17c14de33kb46jha11h8a59h10i16jkb80d11i3c23ad67hc16a262hikb189ea55h6ib46kc26a2i4d13i4d5a2c58",
      ".17c14de33kb46ja62je11k32b80dia8c28ad67hc16a262hikb189ea57h2ahib46kc26ai4d14i3d7ac58",
      ".17c14de33kb46ja61deb123dac36ad67ac16a263idk54e32b103kia16h6a19ha4ha2h10ijb46kc26ai3d25ac58",
      ".17c14de33kb46ja61jb124dacac34ad67ac16a264id7i25h2a5h11a35heb102kei16d6j4d8j26b47kc26ai3d25hc58",
      ".17c14de33kb46ja61jb124dac36ad19i2d46ac17a264h8a10ha23h4a40ib103k19b89kc26ai3d25hc58",
      ".17c14de33kb46ja60hjb124dac25a11d20i36d8i3hc18a350hb211kac25ad28hc58",
      ".17c14de33kb46ja60hjb124dac15hi10d29hac7a9c14a13c22a350ib211kac25ad28ac58",
      ".17c14de33kb46ja60hjb124dac14hidi7d31ac38a4c24a350ib196k6e3k6hac25ad28ac58",
      ".17c14de33kb46ja60hjb124dc15hd40ac66a58h10a282ib195kea3c4a5h2ac26ad28ac58",
      ".17c14de33kb46ja60hjb123edc15hd40ac66a10h24i9d25a282ib195eac8a6c27ad28ac58",
      ".17c14de33kb46ja58hahjb61k27e35jhc15id40ac65ale5k60bejha280hb195ec42ad28ac58",
      ".17c14dje32kb46jaca58hjb60kjf62ac15id40ac65jeb67eha280hb195ec13a2c27ad28ac58",
      ".20c11idj15e18kb45jda8h7a37h7djb59kjf63ac15id40ac65jb68eha280heb193ejc42hd27ia2c57",
      ".32c15hje47b17jd46j14b60kjf63ac15id40ac65jb68eha281ie5l12e14l20j11l22b82kj27ac42hd27i2a40c18",
      ".32c16ie48b137kjf63ac15id40hc65lb68ea282h4a29h10a41jlb80kji11h16ac42hd10i3d13i10d32hac17",
      ".32c16ie48b137kjf63ac15id40hc65lb68ea366hjb80kih13a15c42ahd6i7d12i9d34hc17",
      ".32c16ie48b137kjf63ac15id40hc65lb68ea366hjb80kih14a11h2ac43a9c3ai3d10i7d36hc17",
      ".32c15aie48b137kjf63ac15id14id25ac46ac18lb68ea366hjb80kih13a12h2ac56ai2d11i5d37hc17",
      ".32c15aie48b137kjf63ac15id11h4i24ha2c31a4c5a7c17lb68eaca113h7a244hjb80kih13a12h2ac56ai2d14id38hc17",
      ".32c15aie48b137kjf63ac15id10hac8a6c10a4hi47hac16lb68eha17h2a79h15i8a245jb80kih14a11h2ac56ai2d53ac17",
      ".32c15aie48b136kejf63ac15hd9iac28ai2d2i5d40hc16lb68kei10d21j27l19e21k22eia244jb80kih15a10h2ac56ai2d53ac17",
      ".32c15aie48b109e28jf64ac15hd9iac28aid48hc16lb69k13b108kea244jb80kih15a11ha2c55aid54ac17",
      ".32c15aie48b108e2f92ac15hd8i2ac28aid48hc16lb191ea244jb80kih16a9ha2c56ad55ac17",
      ".32c15aie48b108ef93ac15hd7i3ac29id48hc16lb191ea244jeb79lia2h14a15c53ad55ac17",
      ".32c15aie48b108ef93ac15hidid3i4ac29id48hc16lb191ea245je50l29ia35c14a2c34ad55ac17",
      ".32c16he48b108ef93ac15hi10ac29hd48hc16lb191ea245hi5h10a27h4a16c8a3c34a2hd4i24hc26hd55ac17",
      ".32c16hde47b108ef93ac15hi10ac29hd47ihc16lb191la245h11a6c6a29c57ad29ihc24ahd55ac17",
      ".46c2ahd33e14b108ef93ac15hi10ac29hd47ihc16lb191la245h11a5c7a29c57ad30hc24ahd55hc17",
      ".49a5c29de13b108ef93ac15hi10ac29hd47ihc16lb191laca200c42a15c95ad30hc24ahd55hc17",
      ".49c34ae13b108ef93ac15hi10ac29hd45idihc16leb190lia104h9a5h17i29a36c153ad30hc24ahd55hc17",
      ".49c34ae13b108ef93ac16hi8a2c29hd47ihc16ile20l30b140kli5d22j34l16e3l3e21k59lia35c153ad30hc25h2d54hc17",
      ".49c34ae13b107kef27j11g4j2g33j16fc19a7c30hd47iac16hdf50jb140k7b157kla35c153ad30hc26h20d35hc17",
      ".49c34ae13b88k19ef27dje65j2dj11ic14a28h2d24i12d6i4hc17hif50jb305la35c153ad30hc45h2d34hc17",
      ".49c34ae13b87kef46de80jic12ad24i3ha25c5a2c2a12c20hf51jb305la35c153ad30hc46hd34hc17",
      ".49c34ae13b87ef47de81ic12d26idiac3a5c30a5c22hf51jb305la35c153ad30hc46hd34hc17",
      ".49c34ae13b87ef47de81ic12d26i3ac65hf51jb305la35c153ad30hc46hd34hc17",
      ".49c34ae13b87ef47de81ic12d26idiac65af51jb305la35c154d30hc46hd34hc17",
      ".49c34ae13b87ef47de81ic12d28iac65af51jb305la35c154id29hac45hd34hc17",
      ".49c34he13b87ef47de81ic12d28iac65af51jb305la35c154d30iha8c37hd34hc17",
      ".49c34he14b86ef47de81ic12d28iac65af51jb305laca32c154aid37i7h6ihc24hd34ac17",
      ".49c34he53kb46ef47de81ic12d28iac65af51jeb62k42e17kb182lc96.68c25ai7d38i2d4ihc23hd34ac17",
      ".49c33ahie11l17ge24kb45ef48le80ic12id28ac65af52je11l28j33f49ekb181jc96.68c34a2hd41ic23hd34ac17",
      ".82h3ih16i11le24kb45ef47dle80ic12id28ac65ijg9lg2l11g3f148kb181jc96.68c36ahd40ic23hd34ac17",
      ".84hac26hie24kb45ef45ifdle80ic12id28hc65dge25lgf147kb181jc51h16i6h5a2c16.68c37hd40ic23hd34ac17",
      ".84c29ie24kb45ef47de81ic12id28hac2a5c57de27gf147kb181jc50hid27a2c15.68c37ad40ic23hd34ac17",
      ".84c29ie24kb45kef45dekb44ke35ic12hd28iha7c57de27gf147kb181jc50hd29ac15.68c37ad40ic23hd34ac17",
      ".84c29ie24kb46k48b46ke34i2c12h14d15i28h3ih12i3hc17de27gf147kb181jc50hd29ac15.68c37ad40ic23hd34ac17",
      ".84c29ie24kb140ke35di7d2ac16hd61ihc16de27lf147kb181jc50hd29ac15.68c37ad40iac22h2d32hac17",
      ".84c29ie24kb140ke45dac16d62hc16de27lf147kb181jc50hd29ac15.68c37ad40iac23h15i9h9ac18",
      ".84c29ie24kb140ke46ac16id61hc16de27lf147kb181jc50hd29ac15.68c37ad40iac40ac34",
      ".84c29ie24kb140ke46ac16id61hc16je27lf147lkb179ljc50hd29ac15.68c37aid39iac75",
      ".84c29ie24kb140ke46ac16id61hc16je27lf148l12e10l51g3l14j46d33j12c51hd29ac15.68c37aid39ihc75",
      ".84c29ie24kb140ke46ac16id61hc16je27lf235ha49c16a10c5a11c53hd29ac30.53c37aid40ih19c56",
      ".84c29ie24kb140ke46ac16id61ac16je27lf234ia4c141hd29ac31.52c37aid51i7dihc55",
      ".84c29ie24kb140k2e45ac16id60iac16je27lgf234a2c143hd29ac31.69c20a2id59hc55",
      ".84c29ile23k2b140k22e24ac16id60iac16je28l4e59jf171ac144hd29hac30.69c21a5h9id46hc55",
      ".84c29hil15e9k6b157ke23hc16id60iac15aekb90ejf170c98h13a6h13c15ahd29h2i8h3ac17.69c29a6hid45hc55",
      ".113a2c12a11h3a2je25g9kb123ke23hc16i2d59ihc15e2b92jf170c97h2d30h2c15a2h11id29hac16.69c35aid44ihc55",
      ".114c30je23g11ek15b107ke23hac16i3d57hc3le13b93jf170c97hd32hc18a10hid29ac16.69c33acaid44ihc55",
      ".114c30je23g11e15k2b106ke24h5a8c7a2c5a6hd29ha6c10lebk4b101jf169ic97hd32hc29id29ac16.69c35aid44ihc55",
      ".114c30je23g11e16kb107e36jhc19ahd27iac16lb107jf169ic65a4c2a2c24hd32hc29id29ac16.69c36id42i3hc55",
      ".114c30je23g11e16kb107e37jc20hd27ic17lb107jf168i2c52i8d17ac18ahd32hc29id29ac16.69c36id44ihc55",
      ".114c30je23g11e16kb107e37jc20hd27ic17lb107jf166ifihc51id26ac17ahd32hc29id29ac16.69c36id44ihc55",
      ".114c30je23g11e16kb107e37jc20hd27ic17lb107jf166i3hc51d27ac17ahd32hc29id29ac16.69c36hd45hc55",
      ".114c30je23g11e16kb107e37jc20hd27ic17lb107jf165i4hc51d27ac17ahd32hc29id29ac16.69c36hid44hc55",
      ".114c30le23g11e16kb107e37jc20hd27ic17lb107jf139i3f4i19h4c52d27hc17ahd32hc29id29ac16.69c36ahi3d41h2c54",
      ".114c30le23g11e16kb107e37jc20hd27ic16alb107jf138ihc81d27hc17ahd32hc29id29ac18.2c3.62c37a7h8d31h37c18",
      ".114c30le23g11e16kb107e37jc20hd27ic16alb107jf138hc82d27hc18hd32hc29id29ac32.53c49a2h2d66hac17",
      ".114c30le23g11e16kb107e37jc20hd27ic16alb107jf137ihc82d27hac17hd32hc2a6c21id29iac31.54c.10c39ahd67ac17",
      ".114c30le23g11e16kb108e36jc20ad27ic17lb107jf137ihc82d27hac17hd32iha8c20id30i11hihc18.71c33ahd67ac17",
      ".114c30le23g11e16kb117k3e24jc20aid26ic17lb107j2f134i3hc43i3hi20ac14d27hac17ahd32i14c16id34i10c17.71c33ahd67ac17",
      ".114c30je22lg9jge17kb119ke23jc21aid14i2d8iac17lb106e2j23df14i16f15.28f7i27h7c43i2d23ic14d27ha3c16a11h4d31ihc20a6hd32ic17.71c33ahd67ac17",
      ".114c.c12.19a9c22jle58kb78e23jc28a4c13a3c18lb74ke56jdic36.42c77id24ic14d28ha9c23ahd31hc23a4hd31ic17.71c33ahd67ac17",
      ".147c32le59kb77e24ja8h7a3c32a14leb73ke58ic37.42c77id24ic14ad38ac22ad31hc24acahd31ic17.71c33ahd67ac17",
      ".147c32le59kb77e42jac29ahle14kb73ke58ic37.42c77id24ic15a2h9id27ac21ad31hc24acahd31ic17.71c33ahd67ac17",
      ".147c32le59kb77e43jc29aje15kb73ke58ic37.42c77id24ic21a4chid26ac20a2d31hc26ahd32c17.71c34hd67ac17",
      ".147c32le59kb77e43jc29aje15kb73ke58ic37.42c77i2d23iac26id26ac20a2d31hc26ahd32c17.71c34hd67ac17",
      ".147c32le59kb77e43jc30je15kb73ke58ic37.42c77i2d23iac26id26ac20a2d31hc26ahd32c17.71c34hd67ac17",
      ".147c32le59kb77e43jc30je15kb73ke58ic37.42c77i2d23iac26id26ac20a2d31hc26ahd32c17.71c34hd67ac17",
      ".147c32le59kb77e43jc30je15kb73ke58ic37.42c77id25ac26id26ac20a2d31hc26ahd32c17.71c34hd67ac17",
      ".147c32le59kb77e43jc30je15kb73ke58ic37.42c77id25ac26id26ac20a2d31hc26a2d32c17.71c34hd67ac17",
      ".147c32le59kb77e43jc30je15kb73ke58ic37.42c77id25a2c2a7c16id26ac21ad31ic27ad32c17.71c34h2d66ac17",
      ".147c32le59kb77e43jc30je15kb73ke58ic37.42c77id26h12ac13hd26ac21ad31ic27ad32c17.71c35h19a4h9d35ac17",
      ".147c32le59kb77e43jc30je15kb73ke58ic37.42c36id2i5d13i6ac13hid37hac12hd26ac21ad31ic5a5c3a3c11aid31c17.89c48h2d34ac17",
      ".147c32le59kb77e42j2c30je15kb73ke58ic37.42c35id27iac13h11d28ac12hd26iac20a2d3i2d26ia15c12ai3d27c18.89c48ahd34ac17",
      ".147c32le59kb76e15jd3j25c31jle14kb73ke58ic37.42c34aid27iac13a8c2ahd27ac12hd27i12c17a8hd30hac45.105c48ahd34ac17",
      ".147c32le59k2b61ke20l7dc8a6c47jl9e5k2b71k2e58ic37.42c34aid28ac24ad27ac12aid37i2c24ahd30hc44.106c49hd34ac17",
      ".147c32le60k62edc15a4c78jle5k73e59ic37.42c34ad29a2c23ad27ac13a11id27ic25hd30hc44.106c49hd34ac17",
      ".235e67dc99je98.135c18ad29a2c23ad27ac18a7id26ic25hd30hc44.106c49hd34ac17",
      ".236e66dac98je97.137c17ad29a2c23ad27ac22acaid26ic25hd30hc44.106c49hd34hc17",
      ".236e66dac98je97.137c17ad29a2c24d27ac22a3id26ic25hd30hc44.106c49hd34hc17",
      ".236e66dac98je97.137c17ad29a2c24d27ac24aid26ic25hd30hc44.106c49hd34hc17",
      ".236e66dac98je97.137c18id28a2c24d27ac24aid27c25hd30hac43.106c49hd34hc17",
      ".236e66dac98je97.138c17id28a2c24d27ac25id27c25hd30hac43.106c49hd34hc17",
      ".236e66dc99je97.138c17id28a2c24d27ac25id27c25hd30hac43.106c49hd34hc17",
      ".236e66dc99je97.138c17id28a2c23ad27ac25id27c25hd30hac43.106c49hd34hc17",
      ".236e66dc99je97.138c17id28a4c21ad27a2c2a2c20id27c25hd30hc44.106c49hd34hc17",
      ".236e66dc44hd7i9d18hc19je97.138c17id29a8c16a2d27a12c13id27c25hd30hc44.106c49ahd32h2c17",
      ".236e66dc43hd36hc18je97.138c17hid40hc12a8h4d28ic12id27hc24h2d28h2c44.114c13.2c27a7h27c18",
      ".236e66dc43hd36hc18je97.138c18ah11id29hc13a9h2d28ic12id26ih11c14h30c45.139c69",
      ".236e66dc43hd36hc18je97.138c30hid28hc14a7c2hd28ic16a2c2a3id25i2hc63.164c69",
      ".236e65ldc43hd36hc18jle96.138c31hd28hc14a7c2hd28ic21a3d27ic61.166c69",
      ".245e12.29e11l5ic43hd36hc18djl16e2l2e25.13e11.11e12.142c31hd28hc23hd28ic21a3d27ic61.166c69",
      ".330c16hd36hc19h.234c31hd28hc23hd28ic20a4d28c61.166c69",
      ".331c15hd36hc31.223c31id28hc23hd28ic20a4d28c61.166c69",
      ".331c15hd36hc31.227c27id28hc23hd28ic20a4d28c61.166c69",
      ".331c15hd36h2c30.240c14id28hc23hid27ic20a4d28c61.166c69",
      ".331c15ad37h4a8c19.240c14id28hc23hid27ic21a3d28ac60.166c69",
      ".331c15ad41i8ac18.240c14id28hac22hid27ic21a3d28ac60.166c69",
      ".331c15ahd42i4di2c18.240c14id28hac22hd28ic21a3d28ac60.166c69",
      ".331c16h5i10d28i4d2ic18.240c14hd28hac22hd29ac22ad28ac60.166c69",
      ".331c30hid34c18.240c14hd28hac22hd29ac22ad28c61.166c69",
      ".331c31hd34c18.240c14hd28hc23hd29c24id27c61.166c69",
      ".331c31hd34ac17.240c14ahd26hac24hd27c26id25ac61.166c69",
      ".331c31hd34ac17.240c15a28c27a14c40a24c62.167c.7c8.11c17.3c20.",
      ".331c31hd34ac17.240c149.296",
      ".344c18id34ac17.254c135.296",
      ".346c16id34hc28.243c135.296",
      ".346c16id35h11ac16.243c135.296",
      ".346c16id46hac15.243c135.296",
      ".346c16id47ac15.243c135.296",
      ".346c16id47ac15.243c135.296",
      ".346c16hid46ac15.243c135.296",
      ".346c17h14d33ac15.243c135.296",
      ".346c30ahd32ac15.243c135.296",
      ".346c31ad32ac15.243c135.296",
      ".346c31ad32ac15.243c135.296",
      ".346c31ad32ac15.243c135.296",
      ".346c31ad32ac15.243c135.296",
      ".346c31ad32a2c14.243c135.296",
      ".361c16ad33a10c17.662",
      ".361c16ad43ac16.662",
      ".361c16ad44ac15.662",
      ".361c16ad44ac15.662",
      ".361c16ad44ac15.662",
      ".361c16ad44ac15.662",
      ".361c16ad44ac15.662",
      ".361c16ad44ac15.662",
      ".361c16ad44ac15.662",
      ".361c16ad44ac15.662",
      ".361c16ad44hc15.662",
      ".361c16ahd43hc15.662",
      ".362c16ahi12h21i5d3hc16.662",
      ".376c62.662",
      ".377c61.662",
      ".377c61.662",
      ".377c61.662",
      ".377c61.662",
      ".377c61.662",
      ".377c61.662",
      ".377c61.662",
      ".376c62.662",
      ".376c62.662",
      ".376c62.662",
      ".376c62.662",
      ".388c32.10c5.665"
    ]
  }
};
